var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11079_10288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6538 16.9459L26.6749 26.9248L16.6999 36.899C14.792 38.8076 12.285 39.7615 9.77798 39.7615C7.27095 39.7615 4.76392 38.8076 2.8561 36.899C1.01313 35.0576 -0.00170898 32.599 -0.00170898 29.9771C-0.00170898 27.3545 1.01313 24.8959 2.8561 23.0545L12.8319 13.0771L22.8069 3.10137C26.6241 -0.713477 32.8358 -0.713477 36.653 3.10137C40.4694 6.91934 40.4694 13.1303 36.6538 16.9459Z",
    fill: "#E2EBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8319 13.0769L2.8561 23.0542C1.01313 24.8957 -0.00170898 27.3542 -0.00170898 29.9769C-0.00170898 32.5988 1.01313 35.0574 2.8561 36.8988C3.27642 37.3191 3.72563 37.6933 4.19751 38.0207C3.3311 36.5402 2.86938 34.8464 2.86938 33.0785C2.86938 30.4558 3.88423 27.9972 5.7272 26.1558L15.703 16.1785L15.8178 16.0636L12.8319 13.0769Z",
    fill: "#E5646E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.181 5.08008C38.1794 5.07695 38.1771 5.07383 38.1755 5.0707C37.763 4.3668 37.256 3.70352 36.6529 3.10039C32.8357 -0.714453 26.624 -0.714453 22.8068 3.10039L12.8318 13.077L15.8177 16.0637L25.6779 6.20273C29.0748 2.8082 34.3669 2.43398 38.1818 5.08086L38.181 5.08008Z",
    fill: "#D2D2C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9428 21.1903L15.8178 16.0637L15.703 16.1786L5.7272 26.1559C3.88423 27.9973 2.86938 30.4559 2.86938 33.0786C2.86938 34.8465 3.3311 36.5403 4.19751 38.02C5.8686 39.1801 7.82329 39.7606 9.77798 39.7606C12.285 39.7606 14.792 38.8067 16.6999 36.8981L19.4045 34.1942C18.4811 32.5833 17.953 30.7176 17.953 28.7317C17.953 25.8176 19.0905 23.1637 20.9428 21.1903Z",
    fill: "#FF8086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9768 17.7068C25.8127 17.7068 22.9557 19.0474 20.9439 21.1904C19.0908 23.1638 17.9541 25.8169 17.9541 28.7318C17.9541 30.7177 18.4822 32.5834 19.4057 34.1943C21.3072 37.5138 24.8854 39.7552 28.9775 39.7552C35.0572 39.7552 40.0025 34.8107 40.0025 28.7326C40.0018 22.6529 35.0557 17.7068 28.9768 17.7068Z",
    fill: "#E2EBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8352 28.7318C21.8352 23.3146 25.7617 18.7974 30.9172 17.8779C30.2867 17.7654 29.6383 17.7068 28.9758 17.7068C22.8977 17.7068 17.9531 22.6529 17.9531 28.7318C17.9531 34.8099 22.8977 39.7544 28.9758 39.7544C29.6383 39.7544 30.2867 39.6959 30.9172 39.5834C25.7617 38.6646 21.8352 34.1482 21.8352 28.7318Z",
    fill: "#D2D2C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3313 29.357H21.6219C21.2766 29.357 20.9961 29.0773 20.9961 28.7313C20.9961 28.3852 21.2758 28.1055 21.6219 28.1055H36.3313C36.6766 28.1055 36.957 28.3852 36.957 28.7313C36.957 29.0773 36.6766 29.357 36.3313 29.357Z",
    fill: "#959BA4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11079_10288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPill);
export default __webpack_public_path__ + "static/media/Pill.1c8d8b39387cb3e2c2017da6b91fb71f.svg";
export { ForwardRef as ReactComponent };